<template>
  <div class="custom-dropdown" ref="dropdownRef">
    <button class="dropdown-button" @click="toggleDropdown">
      <img src="@/assets/icons/sidebars/more.svg" alt="" />
    </button>
    <ul class="dropdown-menu" v-if="isOpen">
      <li
        v-for="(option, index) in props.rows"
        :key="index"
        class="dropdown-item"
        @click.stop="selectOption(option)"
        v-show="$psm(option.permissionKey)"
      >
        {{ $t(option?.name) }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from "vue";

// Define props
const props = defineProps({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows: { type: Array as any, default: () => [] },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  item: { type: Object, default: () => {} },
});

// Define emits
const emit = defineEmits(["change"]);

// Dropdown state
const isOpen = ref(false);
const dropdownRef = ref<HTMLElement | null>(null);

// Toggles the dropdown menu
const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const selectOption = (option: any) => {
  emit("change", { ...props.item, stockTypeId: option?.id });
  isOpen.value = false;
};

// Closes the dropdown when clicking outside
const handleOutsideClick = (event: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    isOpen.value = false;
  }
};

// Add and remove event listener for outside clicks
onMounted(() => {
  document.addEventListener("click", handleOutsideClick);
});

onUnmounted(() => {
  document.removeEventListener("click", handleOutsideClick);
});
</script>

<style scoped lang="scss">
/* Base styling */
.custom-dropdown {
  position: relative;
  display: inline-block;

  .dropdown-button {
    border-radius: 10px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 23px;
      height: 23px;
    }
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    right: 4px;
    width: 220px;
    border-radius: 8px;
    list-style: none;
    padding: 0;
    margin: 0;
    z-index: 3;
    overflow: hidden;
  }

  .dropdown-item {
    padding: 10px 15px;
    cursor: pointer;
    font-size: 16px;
    margin: 0;
  }
}

.dark-mode {
  .custom-dropdown {
    .dropdown-button {
      border: 1px solid var(--light);
      background-color: var(--dark);
    }

    .dropdown-menu {
      background: var(--black);
      border: 1px solid var(--dark);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    .dropdown-item:hover {
      background: var(--dark);
    }
  }
}

.light-mode {
  .custom-dropdown {
    .dropdown-button {
      border: 1px solid var(--gray-dark);
      background-color: var(--white);
    }

    .dropdown-menu {
      background: var(--white);
      border: 1px solid var(--white-gray);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    .dropdown-item:hover {
      background: #f0f0f0;
    }
  }
}
</style>
